var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalogue"},[_c('uCatalogueItem',{attrs:{"list":_vm.catalogueTree,"bookName":_vm.bookName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }